import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        {/* Version Desktop du Footer */}
        <div className="footer-content desktop-only">
          <div className="footer-section company-info">
            <div className="footer-logo">
              <img src="/img/logoFdp.webp" alt="FDP AUTOMOBILES" className="logo-img" />
              <div className="logo-text">
                <h3>FDP AUTOMOBILES</h3>
                <p className="company-tagline">Votre partenaire de confiance depuis plus de 45 ans</p>
              </div>
            </div>
            <p className="company-description">
              Spécialiste des véhicules d'occasion à Notre Dame D'Oé, nous vous accompagnons dans l'achat 
              de votre voiture avec expertise et transparence.
            </p>
            <div className="certifications">
              <div className="cert-badge">
                <span className="cert-icon">🇫🇷</span>
                <span>Garantie France</span>
              </div>
              <div className="cert-badge">
                <span className="cert-icon">🛡️</span>
                <span>45 ans d'expérience</span>
              </div>
            </div>
          </div>

          <div className="footer-section contact-info">
            <h4>📍 Notre Adresse</h4>
            <div className="contact-item">
              <p className="address">72 Avenue Gustave Eiffel</p>
              <p className="city">37390 Notre Dame D'Oé</p>
            </div>
            
            <h4>📞 Contact</h4>
            <div className="contact-item">
              <a href="tel:0247540186" className="contact-link">
                02 47 54 01 86
              </a>
              <a href="mailto:fdp-automobiles@live.fr" className="contact-link">
                fdp-automobiles@live.fr
              </a>
            </div>
          </div>

          <div className="footer-section hours-info">
            <h4>🕒 Horaires d'ouverture</h4>
            <div className="hours-list">
              <div className="hours-item">
                <span className="days">Lundi - Vendredi (sauf jours fériés)</span>
                <br />
                <span className="time">10h-12h 14h-18h30</span>
              </div>
              <div className="hours-item">
                <span className="days">Samedi</span>
                <span className="time">10h-12h • 14h-16h</span>
              </div>
              <div className="hours-item closed">
                <span className="days">Dimanche</span>
                <span className="time">Fermé</span>
              </div>
            </div>
          </div>
        </div>

        {/* Version Mobile du Footer */}
        <div className="footer-mobile">
          <div className="footer-mobile-logo">
            <img src="/img/logoFdp.webp" alt="FDP AUTOMOBILES" />
            <h3>FDP AUTOMOBILES</h3>
          </div>

          <div className="footer-mobile-actions">
            <a href="tel:0247540186" className="mobile-action-btn">
              <span className="action-icon">📞</span>
              <span className="action-text">Contactez-nous</span>
            </a>
            <a href="mailto:fdp-automobiles@live.fr" className="mobile-action-btn">
              <span className="action-icon">✉️</span>
              <span className="action-text">Email</span>
            </a>
            <a 
              href="https://www.google.fr/maps/place/72+Av.+Gustave+Eiffel,+37390+Notre-Dame-d'O%C3%A9" 
              target="_blank" 
              rel="noopener noreferrer"
              className="mobile-action-btn"
            >
              <span className="action-icon">📍</span>
              <span className="action-text">Maps</span>
            </a>
          </div>

          <div className="footer-mobile-hours">
            <div className="mobile-hours-header">
              <span className="hours-icon">🕒</span>
              <span>Horaires</span>
            </div>
            <div className="mobile-hours-content">
              <p>Lun-Ven: 10h-12h • 14h-18h30</p>
              <p>Sam: 10h-12h • 14h-16h</p>
              <p className="closed">Dim: Fermé</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">
              &copy; 2025 FDP AUTOMOBILES • Tous droits réservés
            </p>
            <div className="footer-links">
              <Link to="/mentions-legales" className="footer-link">Mentions légales</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 